import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerGlobal = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-height: 100vh;
  align-self: center;
  background-image: url("/imageBackHealth.png");
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ContentForms = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const TopText = styled.div`
  margin-top: 40px;
  text-align: center;
  color: ${Variables.colorRed};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px;
  width: 60%;

  @media (max-width: 820px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  font-weight: 800;
  text-align: center;
  color: ${Variables.colorOrange};
`;

export const Text = styled.h3`
  margin-top: 20px;
  text-align: center;
  color: ${Variables.colorBlackDark};
  font-weight: 400;
  font-family: "Fanwood Text", serif;

  @media (max-width: 820px) {
    width: 100%;
    text-align: center;
  }
`;

export const ContainerBackAndInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 70%;
`;

export const BackButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const TextBack = styled.h3`
  margin-left: 10px;
  font-weight: 600;
  color: ${Variables.colorBlackDark};
`;

export const ContainerReportProblem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  padding: 10px;
  width: 400px;
  background-color: #e9e9e9;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const ImgIcon = styled.img`
  width: 25px;
  height: 25px;
`;

export const ContainerTransparent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 10px 0;
  margin-bottom: 100px;
  padding: 20px 20px;
  width: 90%;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
`;

export const Info = styled.div`
  padding: 10px;
`;

export const TextBold = styled.h3`
  margin: 20px 0;
  width: 100%;
  font-size: 1.5em;
  font-weight: 500;
  font-family: "Fanwood Text", serif;
`;

export const TextInformative = styled.h3`
  margin: 10px;
  width: 100%;
  font-size: 1.5em;
  font-weight: 500;
  text-align: center;
  color: #c2820f;
`;

export const ContainerVerify = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  width: 70%;

  @media (max-width: 820px) {
    width: 80%;
  }
`;

export const ContainerUp = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const ImgLeft = styled.img`
  width: 100px;
  height: 140px;
`;

export const ContainerRight = styled.div`
  margin-left: 20px;
  width: 70%;

  @media (max-width: 820px) {
    flex-direction: column;
    margin-left: 0;
    width: 100%;
  }
`;

export const TextVerification = styled.h3`
  padding: 0 4%;
  color: ${Variables.colorBlackDark};
`;

export const ContainerFormVerify = styled.div`
  display: flex;
  justify-content: space-evenly;

  @media (max-width: 820px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const ContainerInputs1 = styled.div`
  padding-top: 20px;
  width: 70%;

  @media (max-width: 820px) {
    width: 100%;
  }
`;

export const TextBoldRed = styled.h3`
  margin-top: 20px;
  width: 100%;
  font-size: 1.2em;
  font-weight: 400;
  color: ${Variables.colorBlack};
  font-family: "Fanwood Text", serif;
`;

export const AnimationLoading = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;

  & :after {
    content: " ";
    display: block;
    margin: 8px;
    width: 64px;
    height: 64px;
    border: 6px solid ${Variables.colorPrimary};
    border-radius: 50%;
    border-color: ${Variables.colorPrimary} transparent ${Variables.colorPrimary} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const HeaderForm = styled.div`
  padding: 10px;
  width: 95%;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;

  &:hover {
    opacity: 0.5;
  }
`;
